import { Alert } from "@/shared";

export function AdminWithdrawalsAlert() {
  const messages = ["* 한번 탈퇴한 회원은 복구가 불가능합니다."];
  return (
    <>
      <Alert messages={messages} />
    </>
  );
}
